<template lang="pug">
  v-container(fluid)
    h2.text-center {{translations.title}}

    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
        )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items", :key="'item'+ind")
                td
                  v-avatar
                    img(alt="Avatar", :src="item.icon != undefined  ? item.icon : imgDefault")
                td
                  span.fantasy__block-width--8 {{ item.name }}
                td {{ item.key }}
                td
                  BaseConfirmDialog(v-if="hasPermission('views.providers.toggleProvider')" @confirm="toggleState(item._id)" v-bind="translations.confirmationDialog.status")
                    template(v-slot="{ on }")
                      v-btn(v-on="on", :color="getColor(item.status)", :loading="loadingToggleProvider" dark rounded) {{ getStatus(item.status) }}
                  v-chip(v-else :color="getColor(item.status)" text-color="white") {{ getStatus(item.status) }}
                //- td
                  ProviderInfoDialog(:buttonText="translations.button")
                td(v-if="hasPermission('views.providers.editProvider')")
                  BaseDialog(type="edit", :title="translationsForm.title.edit + item.name" v-slot="{close, opened}")
                    ProviderEdit(@successEdit="updateProvider(opened,close)", :clearForm="opened", :provider="item", :translations="translationsForm", :accountManagerList="accountManagerListAll")
                td
                  BaseDetailDialog(:button="translations.dialog.iplist.button", :title="translations.dialog.iplist.title + item.name")
                    ProviderIpList(:ips="item.ips", :providerId="item._id", :translations="translationsProviderIpList")
    BaseDialog(v-if="hasPermission('views.providers.createProvider')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
      ProviderCreate(@successCreate="updateProvider(opened,close)", :clearForm="opened", :translations="translationsForm", :accountManagerList="accountManagerListAll")
</template>

<script>

  import ProviderInfoDialog from "@/components/dialogs/info/ProviderInfoDialog";
  import { base64camera } from "@/libs/otherVariables.js";
  import BaseDetailDialog from "@/basecomponents/dialogs/BaseDetailDialog";
  import ProviderIpList from "./components/ProviderIpList";
  import ProviderCreate from './forms/ProviderCreate';
  import ProviderEdit from './forms/ProviderEdit';

  export default {
    name: "ProvidersIndex",
    components: {
      BaseDetailDialog,
      ProviderIpList,
      ProviderInfoDialog,
      ProviderCreate,
      ProviderEdit,
    },
    data:() => ({
      imgDefault: base64camera,
    }),
    computed:{
      translations(){
        return this.$t("views.providersIndex");
      },
      translationsForm(){
        return this.$t("forms.provider");
      },
      translationsProviderIpList(){
        return this.$t("forms.providerIpList");
      },
      headers(){
        let headers = [
           {
           text:'',
           value:'icon',
           sortable:false
          },
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.key,
            value: 'key'
          },
          {
            text: this.translations.tableHeadText.status,
            value: 'status',
            sortable: false
          },
          {
            text: '',
            value: 'status',
            sortable: false
          },
        ];
        if(this.hasPermission('views.providers.editProvider')){
          headers.push(
            {
              text: '',
              value: 'edit',
              sortable: false
            });
        }
        return headers;
      },
      datos(){
        return this.providersListAll.map(provider =>{
          return {
            _id: provider._id,
            name: provider.n,
            key: provider.k != undefined ? provider.k : '',
            value: provider.__v,
            status: provider.d === true,
            mode: {
              fun: provider.m != undefined && provider.m.f != undefined ? provider.m.f : '',
              real: provider.m != undefined && provider.m.r != undefined ? provider.m.r : '',
            },
            platform: {
              desktop: provider.p != undefined && provider.p.d != undefined ? provider.p.d : '',
              mobile: provider.p != undefined && provider.p.m != undefined ? provider.p.m : '',
            },
            ggr: provider.ggr != undefined ? provider.ggr.toString() : '',
            urls: {
              launcher: provider.urls != undefined ? provider.urls.l : '',
              bonusAward: provider.urls != undefined ? provider.urls.ba : '',
              bonusCancel: provider.urls != undefined ? provider.urls.bc : '',
              ping: provider.urls != undefined ? provider.urls.p : '',
              roundDetails: provider.urls != undefined ? provider.urls.rd : '',
              fixedLauncher: provider.urls != undefined ? provider.urls.fl : '',
              baseUrl: provider.urls != undefined ? provider.urls.bu : '',
              gameList: provider.urls != undefined ? provider.urls.gl : '',
            },
            // customFields: provider.customFields,    // TODO, pendiente de ver cómo llega del servidor
            customFields: provider.customFields != undefined? provider.customFields.map(item => {
              return {
                type: item.type,
                text: item.text,
                name: item.name,
                validators: {
                  required: item.validators != undefined && item.validators.required != undefined ? item.validators.required : false,
                  min_valueC: item.validators != undefined && item.validators.minvalue != undefined,
                  min_valueN: item.validators != undefined && item.validators.minvalue != undefined ? item.validators.minvalue : 0,
                  max_valueC: item.validators != undefined && item.validators.maxvalue != undefined,
                  max_valueN: item.validators != undefined && item.validators.maxvalue != undefined ? item.validators.maxvalue : 0,
                  host: item.validators != undefined && item.validators.host != undefined ? item.validators.host : false,
                  email: item.validators != undefined && item.validators.email != undefined ? item.validators.email : false,
                },
                items: item.items != undefined ? item.items : [],
              };
            }) : [],
            // customFields: [
            //   {
            //     "type":"string",
            //     "label":"text",
            //     "name":"text",
            //     "validators": {
            //       "required":true,
            //     },
            //   },
            //   {
            //     "type":"select",
            //     "label":"sad",
            //     "name":"asd",
            //     "validators":{
            //       "required":true,
            //     },
            //     "items":[
            //       {"text":"sAS", "value":"SAS"},
            //       {"text":"sddd", "value":"dsa"}
            //     ]
            //   }
            // ],
            params: provider.params,
            launcherParams: provider.lp,
            invoice: {
              name: provider.inv != undefined ? provider.inv.n : '',
              address: provider.inv != undefined ? provider.inv.a : '',
              vat: provider.inv != undefined ? provider.inv.v : '',
              tax: provider.inv != undefined ? provider.inv.t : '',
              phone: provider.inv != undefined ? provider.inv.p : '',
              email: provider.inv != undefined ? provider.inv.m : '',
            },
            icon: provider.i,
            ips: provider.ips != undefined ? provider.ips : [],
            cfg: {
              rst: provider.cfg != undefined && provider.cfg.rst === true,
              amb: provider.cfg != undefined && provider.cfg.amb === true,
              rnc: provider.cfg != undefined && provider.cfg.rnc === true,
              anr: provider.cfg != undefined && provider.cfg.anr === true,
              aoc: provider.cfg != undefined && provider.cfg.aoc === true,
              cl: provider.cfg != undefined && provider.cfg.cl === true,
              hfr: provider.cfg != undefined && provider.cfg.hfr === true,
            },
          }
        })
      },
      providersListAll() {
        return this.$store.state.providers;
      },
      accountManagerListAll(){
        return this.$store.state.accountManagers.map(user => {
          return {
            text:user.name,
            value:user.id
          }
        })
      },
      loadingToggleProvider(){
        return this.$store.state.statusCode.toggleProvider.loading;
      },
      stateToggleProvider(){
        return this.$store.state.statusCode.toggleProvider.state;
      },
    },
    watch: {
      stateToggleProvider: function(val){
        if (val == 200){
          this.getProviders();
        }
      },
    },
    created(){
      this.$store.dispatch('getProviders');
      this.$store.dispatch('getAccountManagers');
    },
    methods:{
      getColor(type){
        return type == undefined || type == false ? 'green' : 'red' ;
      },
      getStatus(type){
        return type == undefined || type == false ? this.translations.status.enabled : this.translations.status.disabled;
      },
      getProviders(){
        this.$store.dispatch('getProviders');
      },
      updateProvider(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.getProviders();
        }
      },
      toggleState(providerId){
        this.$store.dispatch('toggleProvider', providerId);
      },
    }
  }
</script>

<style lang="sass">
</style>